var SpeechManager = {
	speechFile:"",
	tapPlay:false,
	paused:false,
	loader:null,
	notVisible:false,
	isMuted:false,
	selectingLang:false,
	hovering: [],
	tipPlayer: null,
	currentSpeech: null,
	forcePause: false,

	init: function() {

		AppEvent.on(player, "afterLoad", SpeechManager.afterLoad);
		AppEvent.on(player, "placeReady", SpeechManager.placeReady);
		SpeechManager.icon = $("<div class='speech_widget' id='spw'><a href='javascript:void(null);' title='" + TPL.lng("speech.on", "Kliknij aby odsłuchać lektora") + "' onclick='SpeechManager.speak(1);' data-speakgroup='TIPS' data-speak='HTML5.speech.on' class='speaks'><img src='assets/lector2.png' id='lector_icon' width='45'></a></div>");
		SpeechManager.cloader = $("<canvas id='spm_loader' width='54' height='52'></canvas>");

		$("#overlay").append(SpeechManager.cloader);
		$("#overlay").append(SpeechManager.icon);
	
		AppEvent.on(player, "BOTTOMBAR.TOGGLE",SpeechManager.bottomBar);
		AppEvent.on(player, "MENU.INFOWINDOW.TOGGLE", SpeechManager.infowindow);

		AppEvent.on(player, "SOUND.MUTED", function(pe) {
			if (Volume.lektor.isMuted()) {
				SpeechManager.isMuted = true;
				var sp = document.getElementById("speech");
				sp.muted = SpeechManager.isMuted;
			}
		});

		AppEvent.on(player, "VOLUME.SET", function() {
			var sp = document.getElementById("speech");
			sp.volume = Volume.currentSpeechVolume();
		});

		AppEvent.on(player, "SOUND.UNMUTED", function(pe) {
			if (!Volume.lektor.isMuted()) {
				SpeechManager.isMuted = false;
				var sp = document.getElementById("speech");
				sp.muted = SpeechManager.isMuted;
			}
		});

		AppEvent.on(player, "AUTOPLAY.STARTED", function(pe) {
			var sp = document.getElementById("speech");
			if (SpeechManager.hasSpeech()) sp.pause();
		});

		AppEvent.on(Autoplay, "AUTOPLAY.FINISHED", function(pe) {
			var sp = document.getElementById("speech");
			sp.pause();
			if (SpeechManager.hasSpeech()) sp.currentTime = 0;
		});

		AppEvent.on(Autoplay, "AUTOPLAY.PAUSED", function(pe) {
			var sp = document.getElementById("speech");
			if (SpeechManager.hasSpeech()) sp.pause();
		});

		AppEvent.on(Autoplay, "AUTOPLAY.RESUMED", function(pe) {
			var sp = document.getElementById("speech");
			if (SpeechManager.hasSpeech()) sp.play();
		});

		AppEvent.on(LanguageMenu, "LANGSELECTION.SHOW", function() {
			SpeechManager.selectingLang = true;
		});

		AppEvent.on(player, "VOLUME.SET", function() {
			AudioManager.setAllVolumes(Volume.currentTipVolume());
		});

		SpeechManager.enableSpeech("#hotspots", ".speaks", 0, "HOTSPOT");

		SpeechManager.tab = Tab.add("speech", {
			"focus": function(m) {
				//console.log("focus info");
				$("#spw").addClass("focused");
				$("#spw a").focus();
			},

			"blur": function(m) {
				//console.log("blur info");
				$("#spw").removeClass("focused");
			}
		});
	},

	pause: function() {
		var sp = document.getElementById("speech");
		if (SpeechManager.hasSpeech()) sp.pause();
	},

	resume: function() {
		var sp = document.getElementById("speech");
		if (SpeechManager.hasSpeech()) sp.play();
	},
	
	infowindow: function(open) {
		if (open) {
			SpeechManager.icon.addClass("slide");
			SpeechManager.cloader.addClass("slide");
		} else {
			SpeechManager.icon.removeClass("slide");
			SpeechManager.cloader.removeClass("slide");
		}
	},

	hideWidget: function(st) {
		if (SpeechManager.hasSpeech()) {
			if (st) {
				$("#spm_loader").css("display", "none");
				$(".speech_widget").css("display", "none");
			} else {
				$("#spm_loader").css("display", "inline");
				$(".speech_widget").css("display", "block");
			}
		}
	},

	bottomBar: function(o) {		
		SpeechManager.notVisible = !o.display;
		if (SpeechManager.speechFile != undefined && SpeechManager.speechFile != "") {		
			if (o.display) {
				SpeechManager.icon.show();
				SpeechManager.cloader.show();
			} else {
				SpeechManager.icon.hide();
				SpeechManager.cloader.hide();
			}
		}
	},

	afterLoad: function(data) {
		if (data.desc_speech == undefined || data.desc_speech == "") {
			if (data.parentplace != undefined && data.parentplace.desc_speech != undefined && data.parentplace.desc_speech.trim() != "") {
				data.desc_speech = data.parentplace.desc_speech;
			}
		}

		

		Tab.groups["speech"].disable();
		if (SpeechManager.speechFile == data.desc_speech) return;

		SpeechManager.speechFile = data.desc_speech;
		//console.log("Speech: " + SpeechManager.speechFile);

		$("#lector_icon").attr("class","");
		$("#lector_icon").attr("src","assets/lector2.png");
		SpeechManager.tapPlay = false;

		if (SpeechManager.speechFile != undefined && SpeechManager.speechFile != "") {
			AppEvent.on(player, "onProcess", SpeechManager.process);
		
			//#menubutton	
			if (!SpeechManager.notVisible && data.folder.speech != "0") {
				SpeechManager.icon = $("#spw");
//				SpeechManager.cloader = $("spm_loader");
				SpeechManager.icon.show();
				SpeechManager.cloader.show();
			}
			
			SpeechManager.loader = new CLoader("spm_loader");
			SpeechManager.loader.style.thickness = 4;
			//document.getElementById("speech_mp3").src = data.desc_speech;
			//document.getElementById("speech").src = data.desc_speech;
			//document.getElementById("speech").load();
			//document.getElementById("speech").play();		
			if (data.folder.speech != "0" && (data.speech == undefined || data.speech.autostart != "click") && !SpeechManager.forcePause) SpeechManager.speak();
			Music.pingMute();			

			Tab.groups["speech"].enable();
		} else {
			SpeechManager.icon.hide();
			SpeechManager.cloader.hide();

			if (data.speech != undefined && data.speech.silencemode == 'force') {
				document.getElementById("speech").pause();
			}
		}

		/*
		var sp = document.getElementById("speech");
		sp.pause();
		*/
	},
		
	placeReady: function() {
	},

	hasSpeech: function() {
		return (SpeechManager.speechFile != "" && SpeechManager.speechFile != undefined) ? true : false;
	},

	speaks: function() {
		return SpeechManager.tapPlay;
	},

	speak: function(force) {		

		if (!SpeechManager.tapPlay && SpeechManager.hasSpeech() && !SpeechManager.selectingLang) {

			$("#lector_icon").attr("src","assets/uploading.png");
			$("#lector_icon").attr("class","blink");

			if (player.offline)
				document.getElementById("speech").src = "data" + SpeechManager.speechFile;
			else
				document.getElementById("speech").src = SpeechManager.speechFile;

			if (SpeechManager.tipPlayer != undefined) SpeechManager.tipPlayer.stop();

			document.getElementById("speech").load();
			document.getElementById("speech").addEventListener("canplay", function() {
				$("#lector_icon").attr("class","");
				$("#lector_icon").attr("src","assets/lector.png");
			});

			document.getElementById("speech").addEventListener("ended", function() {
				$("#lector_icon").attr("src","assets/lector.png");
				AppEvent.trigger(SpeechManager, "SPEECH.FINISHED", {});
				SpeechManager.tapPlay = false;
			});

			document.getElementById("speech").play();
			SpeechManager.tapPlay = true;

		} else {

			var sp = document.getElementById("speech");
			sp.muted = SpeechManager.isMuted;

			if (sp.paused) {
				$("#lector_icon").attr("class","");
				$("#lector_icon").attr("src","assets/lector_playing.png");
				sp.play();
				if (force) this.forcePause = false;
				$("#spw").find("a").data("speak", "HTML5.speech.on");
			} else {
				$("#lector_icon").attr("class","");
				$("#lector_icon").attr("src","assets/lector.png");
				sp.pause();
				if (force) this.forcePause = true;
				$("#spw").find("a").data("speak", "HTML5.speech.off");
			}

		}
		
	},
	
	prepareTip: function(tsymbol, grp) {
		var filemp3 = "";

		var dlang = undefined;
		if (LanguageMenu.data != undefined)
			dlang = LanguageMenu.data.lang;

		if (dlang == undefined) dlang = "PL";

		if (grp == "TIPS" && !player.offline) filemp3 = "/sounds/tips/" + dlang + "_" + tsymbol + ".mp3";

		if (grp == "TOPMENU" && !player.offline) {
			filemp3 = "/text2speech.php?grp=topmenu&lng=" + dlang + "&text=" + tsymbol + ".mp3";
		}
		if (grp == "TIPS" && player.offline) filemp3 = "sounds/tips/" + dlang + "_" + tsymbol + ".mp3";

		AudioManager.load(filemp3);

		//this.filemp3 = filemp3;
		//this.audiotip = new AudioPlayer("speechtip");
		//this.audiotip.forceAudioElement();

		//this.audiotip.loadSound(filemp3);
		//this.audiotip.setVolume(0.04);
		//this.audiotip.setVolume(0.2);

		/*
		document.getElementById("speechtip").src = filemp3;
		document.getElementById("speechtip").load();
		document.getElementById("speechtip").volume = 0.04;
		*/
	},

	speakTip: function(tsymbol, grp, volmult) {
		var filemp3 = "";

		var dlang = undefined;
		var pre = "";

		if (typeof tsymbol !== "string") {
			pre = tsymbol.pre != undefined ? tsymbol.pre : "";
			tsymbol = tsymbol.sound;
		}

		if (volmult == undefined) volmult = 1;

		if (Music.isMuted) return;

		if (LanguageMenu.data != undefined)
			dlang = LanguageMenu.data.lang;

		if (dlang == undefined || dlang == null || dlang == "") dlang = "PL";

		if (grp == "TIPS" && !player.offline) filemp3 = "/sounds/tips/" + dlang + "_" + tsymbol + ".mp3";
		if (grp == "TOPMENU" && !player.offline) {
			filemp3 = "/text2speech.php?grp=topmenu&folder=" + player.folder + "&lng=" + dlang + "&text=" + tsymbol + ".mp3" + "&pre=" + pre;
		}

		if (grp == "TIPS" && player.offline) filemp3 = "sounds/tips/" + dlang + "_" + tsymbol + ".mp3";
		if (grp == "TOPMENU" && player.offline && dlang == "PL") filemp3 = "sounds/topmenu/" + tsymbol + ".mp3";

		//console.log("tip vol: " + Volume.currentTipVolume());
		//console.log("volmult: " + volmult);
		if (SpeechManager.tipPlayer != undefined) SpeechManager.tipPlayer.stop();
		SpeechManager.tipPlayer = AudioManager.play(filemp3, Volume.currentTipVolume() * volmult);

		/*
		var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

		if (isSafari)
			SpeechManager.tipPlayer = AudioManager.play(filemp3, 0.02);
		else
			SpeechManager.tipPlayer = AudioManager.play(filemp3, 0.2);
		*/
		//this.audiotip.playWhenLoaded();
		//document.getElementById("speechtip").play();
	},

	process: function() {
		if (SpeechManager.tapPlay && !Autoplay.running()) {
			var sp = document.getElementById("speech");
			if (!sp.paused) SpeechManager.loader.progress(sp.currentTime / sp.duration);
			if (!sp.paused && sp.currentTime > 0) {
				if ($("#lector_icon").attr("src") != "assets/lector_playing.png") {
					$("#lector_icon").attr("src","assets/lector_playing.png"); 
					$("#lector_icon").attr("class","");
				}
			}
		} else {
			SpeechManager.loader.progress(0);
		}
	},

	enableSpeech: function($parent, $selector, $preload, $grp) {
		if ($grp == undefined) $grp = "TOPMENU";

		if ($preload == 1) {
			$($parent).find($selector).each(function(idx) {
				var ia = $(this);
				var symbol = ia.attr("data-speak");
				if (symbol != undefined) SpeechManager.prepareTip(symbol, ia.attr("data-speakgroup"));
			});
		}

		$($parent).on("mouseout blur", $selector, function(e) {
			var ia = $(this);			

			if (e.type == 'focusout' && Date.now() - player.lastTabTime > 1000) return;

			SpeechManager.currentSpeech = null;

			if (SpeechManager.hovering[ia.attr("data-speak")] != undefined && SpeechManager.hovering[ia.attr("data-speak")] != null) {
				clearTimeout(SpeechManager.hovering[ia.attr("data-speak")]);
			}
		});

//		$($parent).on("mouseover focus speaks", $selector, function(e) {
		$($parent).on("mouseover speaks", $selector, function(e) {
			var ia = $(this);
			var ctime = Date.now();
			var grp = $grp;

			var sp = document.getElementById("speech");
			if (!sp.paused) return;

			if (e.type == 'focusin' && Date.now() - player.lastTabTime > 1000) return;

//			console.log("cs: " + SpeechManager.currentSpeech);
			if (SpeechManager.currentSpeech != null && SpeechManager.currentSpeech == ia.attr("data-speak")) return;

//			if (Menu.hovering[ia.attr("data-speak")] == undefined || Menu.hovering[ia.attr("data-speak")] == null || ctime - Menu.hovering[ia.attr("data-speak")] > 2500) {
//				Menu.hovering[ia.attr("data-speak")] = ctime;
				if (ia.attr("data-speakgroup") != undefined) grp = ia.attr("data-speakgroup");

				SpeechManager.hovering[ia.attr("data-speak")] = setTimeout(function() {
						SpeechManager.speakTip(ia.attr("data-speak"), grp);
						SpeechManager.hovering[ia.attr("data-speak")] = null;
					}, 500);
//			}

			SpeechManager.currentSpeech = ia.attr("data-speak");
			e.stopPropagation();
		});

	}
}

PluginManager.add(SpeechManager);